export const deadlines = [
  { id: 1, label: "Minutos" },
  { id: 2, label: "Horas" },
  { id: 3, label: "Dias" },
];
